import React, { useEffect, useState } from "react";
import styles from "./FormModalWindowDone.module.scss";
import { PUBLIC_IMAGE } from "../../../constants";
import formStore from "../../../stores/formStore";

const FormModalWindowDone = () => {
  const [isExchanged, setIsExchanged] = useState(false);
  const [providerStatus, setProviderStatus] = useState("");
  const response = formStore.finalData?.response || formStore.finalData || {};
  const providerName =
    String(
      formStore.formData.exchangeProvider ||
        response.provider ||
        response.provider_id ||
        ""
    ).toLowerCase() === "simpleswap"
      ? "SimpleSwap"
      : formStore.formData.exchangeProvider || response.provider || "Provider";
  const createdAt = String(formStore.finalData.datetime || "").replace(",", "");
  const orderId = formStore.formData.transactionId || response.order_id || "Pending";
  const isProviderOrder = Boolean(
    formStore.formData.exchangeOrderId ||
      response.provider ||
      response.provider_id ||
      response.order_id
  );

  const formatStatus = (status: string) => {
    if (!status) return "In process";
    return status
      .replace(/_/g, " ")
      .replace(/\b\w/g, (letter) => letter.toUpperCase());
  };

  const isDoneStatus = (status: string) =>
    ["finished", "completed", "success", "done", "payout_sent"].includes(
      status.toLowerCase()
    );

  const handleStatusCheck = async () => {
    try {
      if (isProviderOrder && orderId && orderId !== "Pending") {
        const res = await fetch(
          `/api/v1/exchange/orders/${encodeURIComponent(orderId)}`
        );

        if (!res.ok) {
          throw new Error(`Provider status request failed: ${res.status}`);
        }

        const result = await res.json();
        const status = String(result.status || "");
        setProviderStatus(status);
        if (isDoneStatus(status)) {
          setIsExchanged(true);
        }
        return;
      }

      const res = await fetch(
        "/api/v1/exchange/newcheckPayd",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formStore.formData),
        }
      );

      if (!res.ok) {
        throw new Error(`Ошибка сервера: ${res.status}`);
      }

      const result = await res.json();

      if (result.status !== "no") {
        setIsExchanged(true);
      }
    } catch (error) {
      console.error("Ошибка при выполнении fetch-запроса checkPayd:");
    }
  };

  useEffect(() => {
    handleStatusCheck();
    const intervalId = setInterval(() => {
      handleStatusCheck();
    }, 30000);
    return () => clearInterval(intervalId);
  }, []);

  const handleButtonClose = () => {
    formStore.setDataValid(undefined);
  };

  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div className={styles.modal__window}>
      <img className={styles.modal__widowClose} src={PUBLIC_IMAGE + "closeForm.svg"} onClick={handleButtonClose}></img>
      <div className={styles.modal__windowWrapper}>
        <div className={styles.modal__eyebrow}>Exchange order</div>
        <div className={styles.modal__title}>Payment in progress</div>
        <div className={styles.provider__badge}>{providerName}</div>
        <div className={styles.modal__application}>
          The provider will continue the exchange after deposit confirmation.
          The transaction may be checked according to AML policy.
        </div>
        <div className={styles.modal__summary}>
          <div className={styles.summary__row}>
            <div className={styles.summary__label}>You send</div>
            <div className={styles.summary__value}>
              {formStore.formData.paySelect} {formStore.formData.pay}
            </div>
          </div>
          <div className={styles.summary__row}>
            <div className={styles.summary__label}>You receive</div>
            <div className={styles.summary__value}>
              {formStore.formData.receiveSelect} {formStore.formData.receive}
            </div>
          </div>
          <div className={styles.summary__row}>
            <div className={styles.summary__label}>Order ID</div>
            <div className={`${styles.summary__value} ${styles.summary__hash}`}>
              {orderId}
            </div>
          </div>
        </div>
      </div>
      <div className={styles.modal__timeStatus}>
        <div className={styles.timestatus__wrapper}>
          <div className={styles.timestatus__timeText}>Created</div>
          <div className={styles.timestatus__dateTime}>
            {createdAt}
          </div>
        </div>
        <div className={styles.timestatus__line}></div>
        <div className={styles.timestatus__wrapper}>
          <div className={styles.timestatus__statusText}>
            Status
          </div>
          <div
            className={`${isExchanged
                ? styles.timestatus__dateTimeCanceledDone
                : styles.timestatus__dateTimeCanceled
              }`}
          >
            {formatStatus(providerStatus)}
          </div>
          <div
            className={`${isExchanged
                ? styles.timestatus__ExchangeDone
                : styles.timestatus__ExchangeDefault
              }`}
          >
            Done
          </div>
        </div>
      </div>
      <div
        className={`${isExchanged ? styles.wallet__imagesDone : styles.wallet__images
          }`}
      >
        <img
          src={PUBLIC_IMAGE + "modalWalletLeft.svg"}
          alt="left wallet"
          className={styles.wallet__imagesLeft}
        />
        <div className={`${isExchanged ? styles.loaderDone : styles.loader
          }`}>
          <div className={styles.dot}></div>
          <div className={styles.dot}></div>
          <div className={styles.dot}></div>
        </div>
        <img src={PUBLIC_IMAGE + "modalWalletRight.svg"} alt="right wallet" />
      </div>
      {/* <div className={styles.modal__attention}>
        Attention! Click on the "Refresh page" button if you want to activate
        the automatic page update. The page will be updated every 30 seconds
      </div>
      <button className={styles.modal__buttonRefresh} onClick={handleReload}>
        Refresh page
      </button> */}
      <div className={styles.modal__bottomLine}></div>
    </div>
  );
};

export default FormModalWindowDone;
